import React from 'react';

function Footer() {

    return (
        <div className='text-center'>
            <small>© All Rights Reserved By Veg box</small>
        </div>
    )
}

export default Footer;